export const Marquee = ({ items = [], className = "", style, testid }) => (
  <div className={`mq ${className}`} style={style} data-testid={testid}>
    <div>
      {[...items, ...items].map((t, i) => (
        <span key={i}>{t}</span>
      ))}
    </div>
  </div>
);
